<div>

  <mat-card class="basisinformationen mat-elevation-z2" id="{{anleitungsdokument.organisationsTyp}}-card">
    <mat-card-title>{{ anleitungsdokument.organisationsTyp | anleitungOrgTypeReadable }}</mat-card-title>

    <mat-card-content>
      @if (anleitungsdokument.fileName === null) {
        <div class="inputFieldFile">
          @if (isAdmin()) {
            <form>
              <ufla-file-upload [multiple]="false"
                                [validators]="fileValidatorOptions"
                                [formControl]="selectedFileControl">
                @if (isFileSizeError()) {
                  <mat-error>Die ausgewählte Datei ist zu groß, die maximale Größe beträgt 150MB.</mat-error>
                }
              </ufla-file-upload>

              <button matButton="filled"
                      aria-label="Hochladen Anleitung"
                      data-qa="upload-button"
                      type="button"
                      [disabled]="!isFilePresent()"
                      (click)="uploadAnleitung()">
                <mat-icon>cloud_upload</mat-icon>
                Hochladen
              </button>
            </form>
          } @else {
            <mat-label>Es steht keine Anleitung zur Verfügung</mat-label>
          }
        </div>
      } @else {
        <!-- ; else noFilePresent -->
        <mat-card-content class="anleitung">
          <table>
            <tr>
              <td style="width:200px"><b>Dateiname</b></td>
              <td style="width:200px"><b>Größe</b></td>
              <td><b>Sichtbar für</b></td>
            </tr>
            <tr>
              <td>{{ this.anleitungsdokument.fileName.split('/')[1] }}</td>
              <td>{{ (this.anleitungsdokument.size).toString(8) }}</td>
              <td>{{ this.anleitungsdokument.organisationsTyp | anleitungOrgTypeReadable:false }}</td>
            </tr>
          </table>
          <div class="file-actions">
            <button matButton="filled"
                    aria-label="Download Anleitung"
                    data-qa="download-button"
                    type="button"
                    (click)="downloadFile(this.anleitungsdokument.organisationsTyp)">
              <mat-icon>get_app</mat-icon>
              Herunterladen
            </button>
            @if (isAdmin()) {
              <button matButton="filled" class="button-warn"
                      aria-label="Lösche Anleitung"
                      data-qa="delete-button"
                      type="button"
                      (click)="deleteAnleitungByRole(this.anleitungsdokument.organisationsTyp)">
                <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                Löschen
              </button>
            }
          </div>
        </mat-card-content>
      }
    </mat-card-content>
  </mat-card>
</div>
